import { render, staticRenderFns } from "./billing-address.vue?vue&type=template&id=7ef95ef0&"
import script from "./billing-address.vue?vue&type=script&lang=js&"
export * from "./billing-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports